import * as actionTypes from '../actions/ActionTypes';

const initialCommonState = {
  challengeAcceptList: [],
  challengeHistoryList: [],
  acceptChallengeData: [],
  challengeStatus: false,
};

const ChallengeReducer = (state = initialCommonState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CHALLENGE_ACCEPT_LIST:
      return {
        ...state,
        challengeAcceptList: [...action.data],
      };
    case actionTypes.SAVE_ACCEPT_CHALLENGE_REQUEST_DATA:
      return {
        ...state,
        acceptChallengeData: action.params === null ? [] : [action.params],
      };
    case actionTypes.UPDATE_CHALLENGE_HISTORY_LIST:
      return {
        ...state,
        challengeHistoryList: [...action.data],
      };
    case actionTypes.UPDATE_CHALLENGE_STATUS:
      return {
        ...state,
        challengeStatus: action.value,
      };
    case actionTypes.LOGOUT: {
      return {
        ...state,
        challengeStatus: false,
        challengeAcceptList: [],
        challengeHistoryList: [],
        acceptChallengeData: [],
        ...initialCommonState,
      };
    }

    default:
      return state;
  }
};

export default ChallengeReducer;
